import { Routes, Route } from "react-router-dom";
import SplashScreen from "./pages/userAuth/splash-screen.jsx";
import Login from "./pages/userAuth/Login.jsx";
import ResetPassword from "./pages/userAuth/reset-password.jsx";
import VerifyPassword from "./pages/userAuth/verify-token.jsx";
import ChangePassword from "./pages/userAuth/change-password.jsx"; //first time login
import StaffDashboard from "./pages/hrDashboard/staff-profile-dashboard.jsx";
import AddStaff from "./pages/hrDashboard/add-staff-page.jsx";
import HRDashboardPage from "./pages/hrDashboard/hr-dashboard-page.jsx";
import AdminPage from "./pages/Admin-Dashboard/admin-dashboard.jsx";
import DashboardRouter from "./pages/dashboard-router";
import EditStaff from "./pages/hrDashboard/edit-staff-modal.jsx";
import RequireAuth from "../src/RequireAuth"; // Adjust the path if it's different
import LogsPage from "./pages/Admin-Dashboard/activityLogs.jsx";
import SubmitTimesheet from "./pages/SubmitTimesheet";
import Timesheets from "./pages/newTimesheetPages/ApproverTimesheetPage.jsx"; // 
import LeaveRequests from "./pages/hrDashboard/LeaveRequestsPage.jsx";
import LeaveRequestForm from "./components/LeaveRequestForm";
import Recruitment from "./pages/hrDashboard/recruitment"; // 
import UserListPage from "./pages/Admin-Dashboard/new-user-list-page.jsx"; // Assuming you have a UserListPage componen
import Documentation from "./pages/Documentation.jsx"; // Import the Documentation component
import DisplinaryInterface from "./pages/DisplinaryInterface.jsx";
import ApproveTimesheets from "./pages/hrDashboard/ApproveTimesheets.jsx"; // Assuming you have an ApproveTimesheets component
import Payroll from "./pages/Payroll.jsx"; // Import the Payroll component
import Sidebar from "./components/ReusableSideBar.jsx";
import Performance from "./pages/Performance.jsx";
import LeaveDashboardPage from "./pages/LeaveDashboardPage";
import ProgramManagerDashboard from "./pages/programManagerDashboard/ProgramManagerDashboard.jsx";
import AddTaskModal from "./pages/programManagerDashboard/AddTaskModal.jsx"; // Import the AddTaskModal component
import TaskPage from "./pages/programManagerDashboard/TaskPage.jsx";
import DonorsPage from "./pages/programManagerDashboard/DonorsPage.jsx"; // Import the DonorsPage component
import ProjectListPage from "./pages/programManagerDashboard/projectCreation.jsx";
import ProjectFormModal from "./components/addprojectmodal.jsx";
import ProgramDirectorDashboard from "./pages/programManagerDashboard/ProgramDirectorDashboard.jsx";
import ReportsPage from "./pages/programManagerDashboard/ReportsPage.jsx";
import PDLeaveRequestsPage from "./pages/programManagerDashboard/PDLeaveRequestsPage.jsx";
import PDDisciplinaryInterface from "./pages/programManagerDashboard/PDDisciplinaryInterface.jsx";
import PDDocumentation from "./pages/programManagerDashboard/PDDocumentation.jsx";
import DirectorTimesheet from "./pages/newTimesheetPages/ApproverTimesheetPage.jsx";
import ProgramManagerTimesheet from "./pages/newTimesheetPages/staffTimesheets.jsx"; // Import the DirectorTimesheet component
import FieldDisciplinaryPage from "./pages/StaffDasboard/FieldDisciplinaryPage.jsx";
import HrAssetsPage from "./pages/hrDashboard/hrAssetsPage.jsx";
import FieldOfficerAssetsPage from "./pages/StaffDasboard/fieldOfficerAssetsPage.jsx";
import RiskRegisterPage from "./pages/Head-Of-Operations/RiskRegisterPage.jsx";
import HoOCDashboard from "./pages/Head-Of-Operations/HoCDashboard.jsx";
import HeadOperationsTimesheet from "./pages/newTimesheetPages/staffTimesheets.jsx";
import MySettingsPage from "./pages/hrDashboard/MySettingsPage.jsx";
import PDSettingsPage from "./pages/programManagerDashboard/PDSettingsPage.jsx";
import WorkPlanUploadModal from "./components/workplan.jsx";
import StaffDashboards from "./pages/StaffDasboard/StaffDashboard.jsx";
import ManagerProjectListPage from "./pages/ManagerListPage.jsx";
import ProjectDetailsPage from "./pages/programManagerDashboard/projectDetailsPage.jsx";
import DisciplinaryInterfaceManager from "./pages/programManagerDashboard/DisplinaryManager.jsx";
import AllActivitiesPage from "./pages/ActivitiesPage.jsx";
import DocumentManager from "./pages/programManagerDashboard/PmDocumentation.jsx";
import ProgramManagerDisciplinaryPage from "./pages/programManagerDashboard/ProgramManagerDisciplinaryPage.jsx";
import ProcurementDashboard from "./pages/programManagerDashboard/PMProcurementDashboard.jsx";
import DirectorProcurementDashboard from "./pages/programManagerDashboard/PDProcurementDashboard.jsx";
import FieldOfficerTimesheet from "./pages/newTimesheetPages/staffTimesheets.jsx";
import TaskDashboard from "./pages/StaffDasboard/TasklistPage.jsx";
import ProgramStaffProcurement from "./pages/StaffDasboard/StaffProcurement.jsx";
import TaskReportModal from "./components/programStaff/TaskReportModal.jsx";
import MyUploads from "./pages/StaffDasboard/MyUploads.jsx";
import PMAssetsPage from "./pages/programManagerDashboard/pmAssetsPage.jsx";
import PDAssetsPage from "./pages/programManagerDashboard/PDAssetsPage.jsx";
import Applicants from "./pages/hrDashboard/Applicants.jsx";
import PayrollPage from "./pages/hrDashboard/PayrollPage.jsx";
import ContractsPage from "./pages/ContractsPage.jsx";


// Imports for Operations Associate Pages
import AssetManagementPage from "./pages/OperationsAssociate/AssetManagementPage.jsx";
import OADisciplinaryPage from "./pages/OperationsAssociate/OADisciplinaryPage";
import HeadOpsDashboard from "./pages/OperationsAssociate/tpEquipmentReview.jsx";
import ActivityResourcesView from "./pages/ActivityResourceView.jsx";
import VendorManagementPage from "./pages/OperationsAssociate/VendorManagementPage.jsx";
import OARequisitionPage from "./pages/OperationsAssociate/OARequisition.jsx";
import MyAssetsPage from "./pages/OperationsAssociate/MyAssetsPage.jsx";
import AssetReturnRequestsPage from "./pages/OperationsAssociate/AssetsReturnManagementPage.jsx";
import OADashboard from "./pages/OperationsAssociate/operationsAssociateDashboard.jsx";
import InventoryManagementPage from "./pages/OperationsAssociate/InventoryManagementPage.jsx";
import OAProcurementDashboard from "./pages/OperationsAssociate/ProcurementDashboard.jsx";
import CreateRFQ from "./components/operationsAssociate/CreateRFQs.jsx";
import CreateRFP from "./components/operationsAssociate/CreateRFPs.jsx";
import CreateBOQ from "./components/operationsAssociate/CreateBOQ.jsx";
import MyInventoryPage from "./pages/OperationsAssociate/MyInventoryPage.jsx";
import ProjectCompliance from "./pages/programManagerDashboard/HOProjects.jsx";
import ProgramManagerAccordion from "./pages/programManagerDashboard/ProjectRequestPage.jsx";
import TravelDashboard from "./pages/OperationsAssociate/TravelDashboard.jsx";
import OperationsAssociateTimesheet from "./pages/newTimesheetPages/staffTimesheets.jsx";
import ProcurementLogisticsReports from "./pages/OperationsAssociate/ProcurementLogisticsReports.jsx";
import ContractManagementSystem from "./pages/Head-Of-Operations/VendorContractsHO.jsx";
import ProjectProcurementPlanning from "./pages/OperationsAssociate/ProcurementPlanning.jsx";
import OASettingsPage from "./pages/OperationsAssociate/OASettingsPage.jsx";
import ProcurementPlansPage from "./pages/Head-Of-Operations/procurementPlansPage.jsx";
import HOCReports from "./pages/Head-Of-Operations/HOCReports.jsx";
import MyResourcesPage from "./pages/OperationsAssociate/MyResourcesPage.jsx";

import HODiscipline from "./pages/Head-Of-Operations/HODiscipline.jsx";
import HOSettings from "./pages/Head-Of-Operations/HOSettings.jsx";
import HODocumentation from "./pages/Head-Of-Operations/hoc-documentation.jsx";
import OODocumentation from "./pages/OperationsAssociate/oa-documentation.jsx";
// Program Manager pages
import ProgramManagerInventoryPage from "./pages/programManagerDashboard/ProgramManagerInventoryPage.jsx";
import EquipmentDashboard from "./pages/Head-Of-Operations/equipmentmgt.jsx";
import ProjectRequirementsView from "./pages/OperationsAssociate/ProjectRequirementsView.jsx";
import PMSettingsPage from "./pages/programManagerDashboard/PMSettingsPage.jsx";
import PMDiscipline from "./pages/programManagerDashboard/PMDiscipline.jsx";


// Finance Officer Pages
import FODisciplinary from "./pages/financeOfficer/FODisciplinary.jsx";
import FOAssetsPage from "./pages/financeOfficer/FOAssetsPage.jsx";
import FOInventoryPage from "./pages/financeOfficer/FOInventoryPage.jsx";
import FinanceDashboard from "./pages/financeOfficer/FinanceOfficerDashboard.jsx";
import FinanceProcurementDashboard from "./pages/financeOfficer/FinanceProcurementDashboard.jsx";
import FinanceSettingsPage from "./pages/financeOfficer/FinanceSettingsPage.jsx";
import FinanceTimesheets from "./pages/newTimesheetPages/staffTimesheets.jsx";
import FOPayroll from "./pages/financeOfficer/FinancePayroll.jsx";
import FODocumentation from "./pages/financeOfficer/finance-documentation.jsx";
import FinanceDashboardPage from "./pages/financeOfficer/FinanceDashboardPage.jsx";


// Field Officer
import FOSettingsPage from "./pages/StaffDasboard/FOSettingsPage.jsx";
import VendorInvoicePage from "./pages/OperationsAssociate/vendorInvoice.jsx";
import ContractManagementSystemHO from "./pages/Head-Of-Operations/VendorContractsHO.jsx";
import VendorManagementPageHO from "./pages/Head-Of-Operations/VendorManagementProfileHO.jsx";
import VendorInvoicePageHO from "./pages/Head-Of-Operations/VendorInvoicesHO.jsx";


const user = JSON.parse(localStorage.getItem("user"));

// This is the main App component that sets up the routes for the application.
const App = () => {
  return (
    <Routes>
      <Route path="/" element={<SplashScreen />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-token" element={<VerifyPassword />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/disciplinary" element={<DisplinaryInterface />} />
      <Route path="/contracts" element={<ContractManagementSystemHO />} />
      <Route path="/contracts-page" element={<ContractsPage />} />
      <Route path="/sidebar" element={<Sidebar />} />
      <Route path="/add-task-modal" element={<AddTaskModal />} />
      <Route path="/task-page" element={<TaskPage />} />
      <Route path="/my-uploads" element={<MyUploads />} />


      <Route path="/user-list" element={<UserListPage />} />

      <Route
        path="/leave-request-form"
        element={<LeaveRequestForm staffId={user?._id} token={user?.token} />}
      />

      <Route path="/leave-dashboard" element={<LeaveDashboardPage />} />
      <Route path="/my-assets" element={<HrAssetsPage />} />
      <Route path="/applicants" element={<Applicants />} />

      {/* Protected Routes */}
      <Route
        path="/leave-requests"
        element={
          <RequireAuth roles={["admin", "hr_officer", "program_director"]}>
            <LeaveRequests />
          </RequireAuth>
        }
      />
      <Route
        path="/staff-dashboard"
        element={
          <RequireAuth roles={["admin", "hr_officer"]}>
            <StaffDashboard />
          </RequireAuth>
        }
      />

      <Route
        path="/add-staff"
        element={
          <RequireAuth roles={["admin", "hr_officer"]}>
            <AddStaff />
          </RequireAuth>
        }
      />

      <Route
        path="/hr-dashboard"
        element={
          <RequireAuth roles={["admin", "hr_officer"]}>
            <HRDashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/admin-dashboard"
        element={
          <RequireAuth roles={["admin"]}>
            <AdminPage />
          </RequireAuth>
        }
      />
      <Route path="/dashboard" element={<DashboardRouter />} />

      <Route
        path="/edit-staff/:id"
        element={
          <RequireAuth roles={["admin", "hr_officer"]}>
            <EditStaff />
          </RequireAuth>
        }
      />

      <Route
        path="/activity-logs"
        element={
          <RequireAuth roles={["admin"]}>
            <LogsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/submit-timesheet"
        element={
          // <RequireAuth roles={["admin"]}>
          <SubmitTimesheet />
          // </RequireAuth>
        }
      />
      <Route path="/timesheets" element={<Timesheets />} />
      <Route
        path="/recruitment"
        element={
          <RequireAuth roles={["admin", "hr_officer"]}>
            <Recruitment />
          </RequireAuth> 
        }
      />

      <Route path="/approve-timesheets" element={<ApproveTimesheets />} />

      <Route path="/payroll" element={<Payroll />} />
        <Route path="/payrolls" element={<PayrollPage />} />

      <Route path="/documentation" element={<Documentation />} />
      <Route path="/performance" element={<Performance />} />
      <Route path="/hr-profile" element={<MySettingsPage />} />
      <Route path="/work-plans" element={<WorkPlanUploadModal />} />

      {/* Add project managemeent routes */}
      <Route path="/program-dashboard" element={<ProgramManagerDashboard />} />
      <Route path="/donor-management" element={<DonorsPage />} />
      <Route path="/projects" element={<ProjectListPage />} />
      <Route path="/director-timesheet" element={<DirectorTimesheet />} />
      <Route path="/project-requests" element={<ProgramManagerAccordion />} />

      <Route path="/pm/timesheet" element={<ProgramManagerTimesheet />} />
      <Route path="/fo/timesheet" element={<FieldOfficerTimesheet />} />

      <Route path="/projects/create" element={<ProjectFormModal />} />
      <Route
        path="/program-director"
        element={
          <RequireAuth roles={["program_director"]}>
            <ProgramDirectorDashboard />
          </RequireAuth>
        }
      />
      <Route path="/pd/procurement" element={<DirectorProcurementDashboard />} />

      <Route path="/pm/projects" element={<ManagerProjectListPage />} />
      <Route path="/pm/projects/:projectId" element={<ProjectDetailsPage />} />
      <Route path="/reports-and-evaluations" element={<ReportsPage />} />
      <Route path="/pm/activitiespage" element={<AllActivitiesPage />} />
      <Route path="/pm/tasks" element={<TaskPage />} />

      <Route path="/pm/displinary" element={<DisciplinaryInterfaceManager />} />
      <Route path="/pm/documentation" element={<DocumentManager />} />
      {/* <Route path="/pm/timesheet" element={<DocumentManager />} /> */}
      <Route path="/pm/procurement" element={<ProcurementDashboard />} />
      <Route path="/requisitions" element={<OARequisitionPage />} />


      <Route
        path="/leave-management"
        element={
          <RequireAuth roles={["admin", "hr_officer", "program_director"]}>
            <PDLeaveRequestsPage />
          </RequireAuth>
        }
      />

      <Route
        path="/disciplinary-management"
        element={
          <RequireAuth roles={["admin", "hr_officer", "program_director"]}>
            <PDDisciplinaryInterface />
          </RequireAuth>
        }
      />
      <Route
        path="/document-management"
        element={
          <RequireAuth roles={["admin", "hr_officer", "program_director"]}>
            <PDDocumentation />
          </RequireAuth>
        }
      />

      <Route
        path="/discipline-management"
        element={
          <RequireAuth
            roles={["admin", "hr_officer", "program_director", "program_manager"]}
          >
            <ProgramManagerDisciplinaryPage />
          </RequireAuth>
        }
      />

      <Route
        path="/program-assets"
        element={
          <RequireAuth
            roles={["admin", "hr_officer", "program_director", "program_manager"]}
          >
            <PMAssetsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/director-assets"
        element={
          <RequireAuth
            roles={["admin", "hr_officer", "program_director", "program_manager"]}
          >
            <PDAssetsPage />
          </RequireAuth>
        }
      />

      {/* Program Manager routes */}

      <Route path="/project-inventory" element={<ProgramManagerInventoryPage />} />
      <Route path="/pm-profile" element={<PMSettingsPage />} />
      <Route path="/pd-profile" element={<PDSettingsPage />} />
      <Route path="/pm-discipline" element={<PMDiscipline />} />






      {/* Field Staff routes */}
      <Route path="/program-staff" element={<StaffDashboards />} />
      <Route path="/my-procurement" element={<ProgramStaffProcurement />} />
      <Route path="/field-assets" element={<FieldOfficerAssetsPage />} />
      <Route path="/fo-profile" element={<FOSettingsPage />} />


      <Route path="/my-discipline" element={<FieldDisciplinaryPage />} />
      <Route path="/my-tasks" element={<TaskDashboard />} />
      <Route path="/reports" element={<TaskReportModal />} />

      {/* Operations Associate routes */}
      <Route
        path="/assets-management"
        element={
          <RequireAuth roles={["admin", "program_director", "operations_associate"]}>
            <AssetManagementPage />
          </RequireAuth>
        }
      />
      <Route path="/operations-assets" element={<MyAssetsPage />} />
      <Route path="/assets-return" element={<AssetReturnRequestsPage />} />
      <Route
        path="/operations-dashboard"
        element={
          <RequireAuth roles={["admin", "operations_associate"]}>
            <OADashboard />
          </RequireAuth>
        }
      />

      <Route path="/inventory-management" element={<InventoryManagementPage />} />
      <Route path="/operations-inventory" element={<MyInventoryPage />} />
      <Route path="/my-resources" element={<MyResourcesPage />} />

      <Route path="/operations-discipline" element={<OADisciplinaryPage />} />

      <Route path="/logistics" element={<HeadOpsDashboard />} />

      <Route path="/resources" element={<ActivityResourcesView />} />
      <Route path="/vendor-management" element={<VendorManagementPage />} />
      <Route path="/oa/procurement" element={<OAProcurementDashboard />} />
      <Route path="/oa/procurement/create-rfq" element={<CreateRFQ />} />
      <Route path="/oa/procurement/create-rfp" element={<CreateRFP />} />
      <Route path="/oa/procurement/create-boq" element={<CreateBOQ />} />
      <Route path="/oa/timesheet" element={<OperationsAssociateTimesheet />} />
      <Route path="/oa/reports" element={<ProcurementLogisticsReports />} />
      <Route path="/project-requirements" element={<ProjectRequirementsView />} />
      <Route path="/project-procurement-planning" element={<ProjectProcurementPlanning />} />
      <Route path="/associate-profile" element={<OASettingsPage />} />

      <Route path="/vendor-invoices" element={<VendorInvoicePage />} />


      {/* Head of Operations routes*/}
      <Route path="/risk-register" element={<RiskRegisterPage />} />
      {/* <Route path="/head-of-operations-dashboard" element={<HoOCDashboard />}/> */}
      <Route
        path="/head-of-operations-dashboard"
        element={
          <RequireAuth roles={["head_of_operations", "admin"]}>
            <HoOCDashboard />
          </RequireAuth>
        }
      />
      <Route path="/hoc-discipline" element={<HODiscipline />} />
      <Route path="/hoc-settings" element={<HOSettings />} />
      <Route path="/vendor-managementHO" element={<VendorManagementPageHO />} />
      <Route path="/vendor-contractsHO" element={<ContractManagementSystemHO />} />
      <Route path="/vendor-invoicesHO" element={<VendorInvoicePageHO />} />
      <Route path="/hoc-documentation" element={<HODocumentation />} />
      <Route path="/oa/documentation" element={<OODocumentation />} />



      {/* <Route path="/project-compliance" element={<ProjectCompliancePage />} /> */}
      <Route path="/project-compliance" element={<ProjectCompliance />} />
      <Route path="/travel" element={<TravelDashboard />} />
      <Route path="/head-of-operations/timesheet" element={<HeadOperationsTimesheet />} />
      <Route path="/vendor-contracts" element={<ContractManagementSystem />} />
      <Route path="/equipment-maintenance" element={<EquipmentDashboard />} />
      <Route path="/hoc-reports" element={<HOCReports />} />


      
      <Route path="/procurement-plans" element={<ProcurementPlansPage/>} />


      {/* Route Paths for Finance Officer */}
      <Route path="/finance-discipline" element={<FODisciplinary />} />
      <Route path="/finance-assets" element={<FOAssetsPage />} />
      <Route path="/finance-inventory" element={<FOInventoryPage />} />
      <Route path="/finance-dashboard" element={<FinanceDashboard />} />
      <Route path="/finance-procurement" element={<FinanceProcurementDashboard />} />
      <Route path="/finance-profile" element={<FinanceSettingsPage />} />
      <Route path="/finance-timesheet" element={<FinanceTimesheets />} />
      <Route path="/finance-payroll" element={<FOPayroll />} />
      <Route path="/finance-documentation" element={<FODocumentation />} />
      <Route path="/finance-overview" element={<FinanceDashboardPage />} />







    </Routes>
  );
};

export default App;
